var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFilledWithAiSparkle = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.9017,
    height: 11.2,
    fill: "none",
    overflow: "visible",
    preserveAspectRatio: "none",
    style: {
      display: "block"
    },
    viewBox: "0 0 11.9017 11.2",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_2a)",
    d: "m5.1348.9342-.8248.3085a.168.168 0 0 0 0 .315l.8248.3085.3085.8248a.168.168 0 0 0 .315 0l.3085-.8248.8248-.3085a.168.168 0 0 0 0-.315L6.0668.9342 5.7584.1094a.168.168 0 0 0-.3151 0zM1.0086 8.6506c-.4091.4092-.4091 1.0743 0 1.4856l.757.757c.409.4091 1.0742.4091 1.4855 0l8.3422-8.3444c.4091-.4091.4091-1.0742 0-1.4855l-.757-.7548c-.4091-.4091-1.0742-.4091-1.4855 0zm9.5936-6.8435L8.305 4.1044l-.5098-.5098 2.2972-2.2972zm-10.4381.757A.253.253 0 0 0 0 2.8004c0 .105.0656.1991.164.2363l1.2362.4638.4638 1.2361a.253.253 0 0 0 .2363.1641.253.253 0 0 0 .2363-.164l.4638-1.2362 1.2361-.4638a.253.253 0 0 0 .1641-.2363.253.253 0 0 0-.164-.2363l-1.2362-.4638L2.3366.8642A.253.253 0 0 0 2.1003.7a.253.253 0 0 0-.2363.164l-.4638 1.2362zM7.8652 8.165a.253.253 0 0 0-.164.2363c0 .105.0656.1991.164.2363l1.2361.4638.4638 1.2362a.253.253 0 0 0 .2363.164.253.253 0 0 0 .2363-.164l.4638-1.2362 1.2362-.4638a.253.253 0 0 0 .164-.2363.253.253 0 0 0-.164-.2363l-1.2362-.4638-.4638-1.236a.253.253 0 0 0-.2363-.1642.253.253 0 0 0-.2363.1641l-.4638 1.2361z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg_2a",
    x1: 0.8738,
    x2: 15.5408,
    y1: -0.7417,
    y2: 11.2694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0072FF"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFilledWithAiSparkle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/filled-with-ai-sparkle.acb0466b93f3c6f48f50d5f85f9eb360.svg";